import React, { Component } from 'react';
import ReportRoutes from './ReportRoutes';

class ReportLayout extends Component {
    render() {
        return (<ReportRoutes {...this.props} ></ReportRoutes>);
    }
}

export default ReportLayout;